<template>
  <div class="step disFlex alignCen">
    <div class="one co">
      1
      <div class="title fco">{{ $t("验证信息") }}</div>
    </div>
    <div class="two"></div>
    <div class="there therenew co bco">
      2
      <div class="title fco">{{ $t("设置新密码") }}</div>
    </div>
    <div class="two"></div>
    <div class="there">
      3
      <div class="title">{{ $t("重置成功") }}</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.step {
  .one {
    width: 36px;
    height: 36px;
    background: #3b5ff0;
    border-radius: 50%;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 36px;
    position: relative;
    .title {
      width: 180px;
      height: 13px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3b5ff0;
      position: absolute;
      bottom: -10px;
      left: -73px;
    }
  }
  .two {
    width: 129px;
    height: 1px;
    border-bottom: 1px dashed #cccccc;
    margin: 0px 5px;
  }
  .there {
    width: 37px;
    height: 36px;
    background: #ffffff;
    border: 1px dashed #999999;
    border-radius: 50%;
    text-align: center;
    line-height: 36px;
    position: relative;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    .title {
      width: 180px;
      height: 13px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      position: absolute;
      bottom: -10px;
      left: -75px;
    }
  }
  .therenew {
    background: #3b5ff0;
    color: #ffffff;
    .title {
      color: #3b5ff0;
    }
  }
}
</style>
